// App.js
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AuthPage from './Auth';
import Header from './Header';
import Home from './Home';
import Form from './Form';
import Dashboard from './Dashboard';
import Register from './register';
import Protectedroute from './Protectedroute';
import PublicRoute from './Publicroute';
import Formsuccess from './Formsuccess';
import PaymentMethods from './PaymentMethods';
import AddPaymentMethod from './AddPaymentMethod';
import CancelSession from './CancelSession';
import MeetTutors from './MeetTutors';
import MyInformation from './MyInformation';
import StripeConnectOnboarding from './StripeConnectOnboarding';
import StripeConnectReturn from './StripeConnectReturn';
import { useStripeConnectRedirect } from './hooks/useStripeConnectRedirect';
import StressTestTool from './StressTestTool';

function AppContent() {
    // This hook will redirect tutors to Stripe onboarding if needed
    useStripeConnectRedirect();
    
    return (
        <main style={{ marginTop: '60px' }}>
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Auth" element={<AuthPage />} />
        <Route path="/meet-tutors" element={<MeetTutors />} />
        
        {/* Stripe Connect routes for tutors */}
        <Route path="/stripe-connect-onboarding" element={
          <Protectedroute>
            <StripeConnectOnboarding />
          </Protectedroute>
        } />
        <Route path="/stripe-connect-return" element={
          <Protectedroute>
            <StripeConnectReturn />
          </Protectedroute>
        } />
        
        {/* Dashboard requires Stripe Connect for tutors */}
        <Route path="/Dashboard" element={
          <Protectedroute requireStripeConnect={true}>
            <Dashboard />
          </Protectedroute>
        } />
        
        {/* My Information page */}
        <Route path="/my-information" element={
          <Protectedroute requireStripeConnect={true}>
            <MyInformation />
          </Protectedroute>
        } />
        
        {/* Payment related routes - redirect to dashboard payment section */}
        <Route path="/payment-methods" element={
          <Protectedroute>
            <Dashboard defaultPage="paymentMethods" />
          </Protectedroute>
        } />
        
        {/* Session cancellation route - no authentication required since token-based */}
        <Route path="/cancel-session/:token" element={<CancelSession />} />
        
        {/* Stress Test Tool - Only for development/testing */}
        <Route path="/stress-test" element={
          <Protectedroute>
            <StressTestTool />
          </Protectedroute>
        } />

        <Route 
        path="/Register"
         element={
         <PublicRoute>
         <Register /> 
          </PublicRoute>
        }
      />

        <Route path="/Formsuccess" element={<Formsuccess />} />        <Route path="/form" element={<Form />} />

        </Routes>
        </main>
    );
}

function App() {
    return (
      <Router>
        <Header />
        <AppContent />
      </Router>
    );
}

export default App;
